import React, { useState, useEffect } from 'react';
import '../app/app.component.css';
import royal_backs from './img/royal-backs-logo.png';
import royal_group from './img/royal-group-logo.png';
import princess_themed from './img/princess-themed.jpeg'
import potter from './img/potter.jpeg'
import meet_greet from './img/meet-greet.jpeg'
import bday from './img/bday.jpeg'
import balloons from './img/balloons.jpeg'

export const PricingPage = () => {
  interface CardItemProps {
    imgSrc: string;
    title: string;
    description: string;
    ctaLink: string;
    ctaText: string;
  }
  const CardItem: React.FC<CardItemProps> = ({ imgSrc, title, description, ctaLink, ctaText }) => (
    <div className="card-item">
      <img src={imgSrc} alt={title} />
      <div className="card-content">
        <h2>{title}</h2>
        <p>{description}</p>
        <a href={ctaLink} className="cta-button" target={"_blank"}>{ctaText}</a>
      </div>
    </div>
  );

  return (
    <main>
      <h1 style={{ textAlign: 'center', marginTop: '50px', display: 'flex', justifyContent: 'center', color: '#496a86', fontFamily: 'cursive', fontSize: '40px' }}>Pricing & Options</h1>
      <div className="second-container">
        <CardItem
          imgSrc={meet_greet}
          title="Public Meet & Greets"
          description="For our Corporate Clients. Add a character to any special event, such as Employee Picnics, Mall Visits, Luncheons, Milestones, Walks/Runs and more."
          ctaLink="https://docs.google.com/forms/d/e/1FAIpQLSemFwp8FmyIylA0-FggpQf7wHyDN-M_i0j8AJbfCDuNsO3p8g/viewform"
          ctaText="GET A QUOTE"
        />
        <CardItem
          imgSrc={princess_themed}
          title="Princess/Themed"
          description="Begin your enchanting journey effortlessly. Just a few clicks away from creating magical memories. Discover more below. Let's make your event unforgettable!"
          ctaLink="https://docs.google.com/forms/d/1vP0df4q3wsXgaKObZK4lBCad68LvJy7XdoUtR978vjc/viewform?edit_requested=true"
          ctaText="BOOK A VISIT"
        />
        <CardItem
          imgSrc={potter}
          title="Superhero/Pokemon"
          description="Share your details for a swift confirmation. Reach out if you need assistance. Let's work together to create enchanting memories!"
          ctaLink="https://docs.google.com/forms/d/e/1FAIpQLSc85_Z9d32oldnzhUqDV6jzqdo9BDVVAjOwdxhBM1BW3gLusg/viewform"
          ctaText="BOOK NOW"
        />
      </div>
      <div>
        <h1 style={{ textAlign: 'center', marginTop: '50px', display: 'flex', justifyContent: 'center', color: '#496a86', fontFamily: 'cursive', fontSize: '35px' }}>The Royal Princess Party Experience</h1>
        <p style={{ color: 'gray', textAlign: 'center' }}>
          Step into an enchanting world where one character, along with a delightful assistant, brings your event to life. Prepare to be mesmerized as your character hosts an unforgettable meet & greet, weaving captivating tales that transport guests to faraway lands. Engage in lively group games, set to the backdrop of themed music that adds an extra layer of magic to the atmosphere. And, as the event draws to a close, experience the grandeur of a coronation ceremony, leaving everyone with cherished memories to treasure for years to come.
        </p>
      </div>
      <div>
        <h1 style={{ textAlign: 'center', marginTop: '50px', display: 'flex', justifyContent: 'center', color: '#496a86', fontFamily: 'cursive', fontSize: '35px' }}>Step into a Superhero Party Visit</h1>
        <p style={{ color: 'gray', textAlign: 'center' }}>
          Embark on an adventure filled with excitement and wonder as one character, accompanied by a reliable assistant, takes center stage at your event. Prepare for an immersive experience as your character orchestrates a dynamic meet & greet, inviting guests into a world of imagination and heroism. Be captivated by enthralling storytelling that transports you to thrilling realms beyond imagination. Engage in heart-pounding group games designed to test your skills and bravery, all within the immersive setting of hero-themed training activities. And finally, culminate your celebration with an unforgettable Birthday hero ceremony, where the guest of honor is hailed as a true hero, leaving a lasting impression on all who attend.
        </p>
      </div>
      <div>
        <h1 style={{ textAlign: 'center', marginTop: '50px', display: 'flex', justifyContent: 'center', color: '#496a86', fontFamily: 'cursive', fontSize: '27px' }}>The Other Stuff</h1>
        <p style={{ justifyContent: 'center', display: 'flex', color: 'gray', marginTop: '-20px' }}>
          <ul style={{ textAlign: 'left', listStylePosition: 'inside' }}>
            <li>TRAVEL FEES: $10.00 Local, $20.00 City plus parking.</li>
            <li>PAYMENTS: Chase Quick Pay, Zelle, Venmo. We do not accept personal checks.</li>
            <li>DEPOSIT: $50.00 - balance due week of party/event.</li>
            <li>PARTY POLICIES: will be provided during the booking process.</li>
            <li>LICENSED & INSURED: Royal Princess Parties is insured and a licensed LLC in the state of Illinois.</li>
          </ul>
        </p>
        <h1 style={{ textAlign: 'center', display: 'flex', justifyContent: 'center', color: '#496a86', fontFamily: 'cursive', fontSize: '27px' }}>Service Areas</h1>
        <p style={{ color: 'gray', textAlign: 'center', marginTop: '-10px' }}>Service areas include, but not limited to: Chicago and surrounding suburbs of Illinois. Cities serviced include, but not limited to: Buffalo Grove, Chicago, Wheaton, Lisle, Des Plaines, Deerfield, Wilmette, Niles, Evanston, Elgin, Barrington, Glenview, Northbrook, Wheeling, Oak Brook, Park Ridge, Winnetka, Highland Park, Highwood, Lake Bluff, Lake Forest, Elk Grove Village, Rosemont, Aurora, Schaumburg, Palatine, Kenilworth, Prospect Heights, Skokie, Glencoe, Long Grove, Inverness, Franklin Park, Orland Park, Norridge, Morton Grove and many more.</p>
      </div>
    </main>
  );
}

export default PricingPage;